function $45ffa6ee91549f09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $45ffa6ee91549f09$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $45ffa6ee91549f09$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $45ffa6ee91549f09$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $45ffa6ee91549f09$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $45ffa6ee91549f09$var$normalizeComputedStyleValue(string) {
    // "250px" --> 250
    return +string.replace(/px/, "");
}
function $45ffa6ee91549f09$var$fixDPR(canvas) {
    var dpr = window.devicePixelRatio;
    var computedStyles = getComputedStyle(canvas);
    var width = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue("width"));
    var height = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue("height"));
    canvas.setAttribute("width", (width * dpr).toString());
    canvas.setAttribute("height", (height * dpr).toString());
}
function $45ffa6ee91549f09$var$generateRandomNumber(min, max) {
    var fractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var randomNumber = Math.random() * (max - min) + min;
    return Math.floor(randomNumber * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
}
function $45ffa6ee91549f09$var$generateRandomArrayElement(arr) {
    return arr[$45ffa6ee91549f09$var$generateRandomNumber(0, arr.length)];
}
var $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION = 0.00125;
var $45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT = 0.0005;
var $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT = 0.0009;
var $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION = 0.00001;
var $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS = 6;
var $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE = 80;
var $45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED = 0.9;
var $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED = 1.7;
var $45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED = 0.2;
var $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED = 0.6;
var $45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED = 0.03;
var $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED = 0.07;
var $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE = 15;
var $45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE = 82;
var $45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT = 150;
var $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD = 100;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER = 250;
var $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER = 40;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS = [
    "#fcf403",
    "#62fc03",
    "#f4fc03",
    "#03e7fc",
    "#03fca5",
    "#a503fc",
    "#fc03ad",
    "#fc03c2"
];
function $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth) {
    var HD_SCREEN_WIDTH = 1920;
    return Math.log(canvasWidth) / Math.log(HD_SCREEN_WIDTH);
}
var $45ffa6ee91549f09$var$ConfettiShape = /*#__PURE__*/ function() {
    function ConfettiShape(args) {
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiShape);
        var initialPosition = args.initialPosition, direction = args.direction, confettiRadius = args.confettiRadius, confettiColors = args.confettiColors, emojis = args.emojis, emojiSize = args.emojiSize, canvasWidth = args.canvasWidth;
        var randomConfettiSpeed = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED, 3);
        var initialSpeed = randomConfettiSpeed * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.confettiSpeed = {
            x: initialSpeed,
            y: initialSpeed
        };
        this.finalConfettiSpeedX = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED, 3);
        this.rotationSpeed = emojis.length ? 0.01 : $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED, 3) * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.dragForceCoefficient = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT, $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT, 6);
        this.radius = {
            x: confettiRadius,
            y: confettiRadius
        };
        this.initialRadius = confettiRadius;
        this.rotationAngle = direction === "left" ? $45ffa6ee91549f09$var$generateRandomNumber(0, 0.2, 3) : $45ffa6ee91549f09$var$generateRandomNumber(-0.2, 0, 3);
        this.emojiSize = emojiSize;
        this.emojiRotationAngle = $45ffa6ee91549f09$var$generateRandomNumber(0, 2 * Math.PI);
        this.radiusYUpdateDirection = "down";
        var angle = direction === "left" ? $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE, $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE) * Math.PI / 180 : $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE, -$45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE) * Math.PI / 180;
        this.absCos = Math.abs(Math.cos(angle));
        this.absSin = Math.abs(Math.sin(angle));
        var positionShift = $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT, 0);
        var shiftedInitialPosition = {
            x: initialPosition.x + (direction === "left" ? -positionShift : positionShift) * this.absCos,
            y: initialPosition.y - positionShift * this.absSin
        };
        this.currentPosition = Object.assign({}, shiftedInitialPosition);
        this.initialPosition = Object.assign({}, shiftedInitialPosition);
        this.color = emojis.length ? null : $45ffa6ee91549f09$var$generateRandomArrayElement(confettiColors);
        this.emoji = emojis.length ? $45ffa6ee91549f09$var$generateRandomArrayElement(emojis) : null;
        this.createdAt = new Date().getTime();
        this.direction = direction;
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiShape, [
        {
            key: "draw",
            value: function draw(canvasContext) {
                var currentPosition = this.currentPosition, radius = this.radius, color = this.color, emoji = this.emoji, rotationAngle = this.rotationAngle, emojiRotationAngle = this.emojiRotationAngle, emojiSize = this.emojiSize;
                var dpr = window.devicePixelRatio;
                if (color) {
                    canvasContext.fillStyle = color;
                    canvasContext.beginPath();
                    canvasContext.ellipse(currentPosition.x * dpr, currentPosition.y * dpr, radius.x * dpr, radius.y * dpr, rotationAngle, 0, 2 * Math.PI);
                    canvasContext.fill();
                } else if (emoji) {
                    canvasContext.font = "".concat(emojiSize, "px serif");
                    canvasContext.save();
                    canvasContext.translate(dpr * currentPosition.x, dpr * currentPosition.y);
                    canvasContext.rotate(emojiRotationAngle);
                    canvasContext.textAlign = "center";
                    canvasContext.fillText(emoji, 0, 0);
                    canvasContext.restore();
                }
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(iterationTimeDelta, currentTime) {
                var confettiSpeed = this.confettiSpeed, dragForceCoefficient = this.dragForceCoefficient, finalConfettiSpeedX = this.finalConfettiSpeedX, radiusYUpdateDirection = this.radiusYUpdateDirection, rotationSpeed = this.rotationSpeed, createdAt = this.createdAt, direction = this.direction;
                var timeDeltaSinceCreation = currentTime - createdAt;
                if (confettiSpeed.x > finalConfettiSpeedX) this.confettiSpeed.x -= dragForceCoefficient * iterationTimeDelta;
                this.currentPosition.x += confettiSpeed.x * (direction === "left" ? -this.absCos : this.absCos) * iterationTimeDelta;
                this.currentPosition.y = this.initialPosition.y - confettiSpeed.y * this.absSin * timeDeltaSinceCreation + $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION * Math.pow(timeDeltaSinceCreation, 2) / 2;
                this.rotationSpeed -= this.emoji ? 0.0001 : $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION * iterationTimeDelta;
                if (this.rotationSpeed < 0) this.rotationSpeed = 0; // no need to update rotation radius for emoji
                if (this.emoji) {
                    this.emojiRotationAngle += this.rotationSpeed * iterationTimeDelta % (2 * Math.PI);
                    return;
                }
                if (radiusYUpdateDirection === "down") {
                    this.radius.y -= iterationTimeDelta * rotationSpeed;
                    if (this.radius.y <= 0) {
                        this.radius.y = 0;
                        this.radiusYUpdateDirection = "up";
                    }
                } else {
                    this.radius.y += iterationTimeDelta * rotationSpeed;
                    if (this.radius.y >= this.initialRadius) {
                        this.radius.y = this.initialRadius;
                        this.radiusYUpdateDirection = "down";
                    }
                }
            }
        },
        {
            key: "getIsVisibleOnCanvas",
            value: function getIsVisibleOnCanvas(canvasHeight) {
                return this.currentPosition.y < canvasHeight + $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD;
            }
        }
    ]);
    return ConfettiShape;
}();
function $45ffa6ee91549f09$var$createCanvas() {
    var canvas = document.createElement("canvas");
    canvas.style.position = "fixed";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.zIndex = "1000";
    canvas.style.pointerEvents = "none";
    document.body.appendChild(canvas);
    return canvas;
}
function $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig) {
    var _confettiConfig$confe = confettiConfig.confettiRadius, confettiRadius = _confettiConfig$confe === void 0 ? $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS : _confettiConfig$confe, _confettiConfig$confe2 = confettiConfig.confettiNumber, confettiNumber = _confettiConfig$confe2 === void 0 ? confettiConfig.confettiesNumber || (confettiConfig.emojis ? $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER : $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER) : _confettiConfig$confe2, _confettiConfig$confe3 = confettiConfig.confettiColors, confettiColors = _confettiConfig$confe3 === void 0 ? $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS : _confettiConfig$confe3, _confettiConfig$emoji = confettiConfig.emojis, emojis = _confettiConfig$emoji === void 0 ? confettiConfig.emojies || [] : _confettiConfig$emoji, _confettiConfig$emoji2 = confettiConfig.emojiSize, emojiSize = _confettiConfig$emoji2 === void 0 ? $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE : _confettiConfig$emoji2; // deprecate wrong plural forms, used in early releases
    if (confettiConfig.emojies) console.error("emojies argument is deprecated, please use emojis instead");
    if (confettiConfig.confettiesNumber) console.error("confettiesNumber argument is deprecated, please use confettiNumber instead");
    return {
        confettiRadius: confettiRadius,
        confettiNumber: confettiNumber,
        confettiColors: confettiColors,
        emojis: emojis,
        emojiSize: emojiSize
    };
}
var $45ffa6ee91549f09$var$ConfettiBatch = /*#__PURE__*/ function() {
    function ConfettiBatch(canvasContext) {
        var _this = this;
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiBatch);
        this.canvasContext = canvasContext;
        this.shapes = [];
        this.promise = new Promise(function(completionCallback) {
            return _this.resolvePromise = completionCallback;
        });
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiBatch, [
        {
            key: "getBatchCompletePromise",
            value: function getBatchCompletePromise() {
                return this.promise;
            }
        },
        {
            key: "addShapes",
            value: function addShapes() {
                var _this$shapes;
                (_this$shapes = this.shapes).push.apply(_this$shapes, arguments);
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _a;
                if (this.shapes.length) return false;
                (_a = this.resolvePromise) === null || _a === void 0 || _a.call(this);
                return true;
            }
        },
        {
            key: "processShapes",
            value: function processShapes(time, canvasHeight, cleanupInvisibleShapes) {
                var _this2 = this;
                var timeDelta = time.timeDelta, currentTime = time.currentTime;
                this.shapes = this.shapes.filter(function(shape) {
                    // Render the shapes in this batch
                    shape.updatePosition(timeDelta, currentTime);
                    shape.draw(_this2.canvasContext); // Only cleanup the shapes if we're being asked to
                    if (!cleanupInvisibleShapes) return true;
                    return shape.getIsVisibleOnCanvas(canvasHeight);
                });
            }
        }
    ]);
    return ConfettiBatch;
}();
var $45ffa6ee91549f09$var$JSConfetti = /*#__PURE__*/ function() {
    function JSConfetti() {
        var jsConfettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $45ffa6ee91549f09$var$_classCallCheck(this, JSConfetti);
        this.activeConfettiBatches = [];
        this.canvas = jsConfettiConfig.canvas || $45ffa6ee91549f09$var$createCanvas();
        this.canvasContext = this.canvas.getContext("2d");
        this.requestAnimationFrameRequested = false;
        this.lastUpdated = new Date().getTime();
        this.iterationIndex = 0;
        this.loop = this.loop.bind(this);
        requestAnimationFrame(this.loop);
    }
    $45ffa6ee91549f09$var$_createClass(JSConfetti, [
        {
            key: "loop",
            value: function loop() {
                this.requestAnimationFrameRequested = false;
                $45ffa6ee91549f09$var$fixDPR(this.canvas);
                var currentTime = new Date().getTime();
                var timeDelta = currentTime - this.lastUpdated;
                var canvasHeight = this.canvas.offsetHeight;
                var cleanupInvisibleShapes = this.iterationIndex % 10 === 0;
                this.activeConfettiBatches = this.activeConfettiBatches.filter(function(batch) {
                    batch.processShapes({
                        timeDelta: timeDelta,
                        currentTime: currentTime
                    }, canvasHeight, cleanupInvisibleShapes); // Do not remove invisible shapes on every iteration
                    if (!cleanupInvisibleShapes) return true;
                    return !batch.complete();
                });
                this.iterationIndex++;
                this.queueAnimationFrameIfNeeded(currentTime);
            }
        },
        {
            key: "queueAnimationFrameIfNeeded",
            value: function queueAnimationFrameIfNeeded(currentTime) {
                if (this.requestAnimationFrameRequested) // We already have a pended animation frame, so there is no more work
                return;
                if (this.activeConfettiBatches.length < 1) // No shapes to animate, so don't queue another frame
                return;
                this.requestAnimationFrameRequested = true; // Capture the last updated time for animation
                this.lastUpdated = currentTime || new Date().getTime();
                requestAnimationFrame(this.loop);
            }
        },
        {
            key: "addConfetti",
            value: function addConfetti() {
                var confettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _normalizeConfettiCon = $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig), confettiRadius = _normalizeConfettiCon.confettiRadius, confettiNumber = _normalizeConfettiCon.confettiNumber, confettiColors = _normalizeConfettiCon.confettiColors, emojis = _normalizeConfettiCon.emojis, emojiSize = _normalizeConfettiCon.emojiSize; // Use the bounding rect rather tahn the canvas width / height, because
                // .width / .height are unset until a layout pass has been completed. Upon
                // confetti being immediately queued on a page load, this hasn't happened so
                // the default of 300x150 will be returned, causing an improper source point
                // for the confetti animation.
                var canvasRect = this.canvas.getBoundingClientRect();
                var canvasWidth = canvasRect.width;
                var canvasHeight = canvasRect.height;
                var yPosition = canvasHeight * 5 / 7;
                var leftConfettiPosition = {
                    x: 0,
                    y: yPosition
                };
                var rightConfettiPosition = {
                    x: canvasWidth,
                    y: yPosition
                };
                var confettiGroup = new $45ffa6ee91549f09$var$ConfettiBatch(this.canvasContext);
                for(var i = 0; i < confettiNumber / 2; i++){
                    var confettiOnTheRight = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: leftConfettiPosition,
                        direction: "right",
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    var confettiOnTheLeft = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: rightConfettiPosition,
                        direction: "left",
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    confettiGroup.addShapes(confettiOnTheRight, confettiOnTheLeft);
                }
                this.activeConfettiBatches.push(confettiGroup);
                this.queueAnimationFrameIfNeeded();
                return confettiGroup.getBatchCompletePromise();
            }
        },
        {
            key: "clearCanvas",
            value: function clearCanvas() {
                this.activeConfettiBatches = [];
            }
        },
        {
            key: "destroyCanvas",
            value: function destroyCanvas() {
                this.canvas.remove();
            }
        }
    ]);
    return JSConfetti;
}();
var $45ffa6ee91549f09$export$2e2bcd8739ae039 = $45ffa6ee91549f09$var$JSConfetti;


const $5f9f4b115dc0e870$var$jsConfetti = new (0, $45ffa6ee91549f09$export$2e2bcd8739ae039)();
const $5f9f4b115dc0e870$var$number = document.querySelector(".numer--js");
const $5f9f4b115dc0e870$var$adder = document.querySelector(".add--js");
const $5f9f4b115dc0e870$var$subber = document.querySelector(".sub--js");
let $5f9f4b115dc0e870$var$time;
let $5f9f4b115dc0e870$var$hour;
let $5f9f4b115dc0e870$var$minute;
let $5f9f4b115dc0e870$var$key = new Date().toLocaleString().slice(0, 10);
console.log($5f9f4b115dc0e870$var$key);
let $5f9f4b115dc0e870$var$status;
let $5f9f4b115dc0e870$var$glasNumber;
window.addEventListener("load", (event)=>{
    $5f9f4b115dc0e870$var$status = "Offline";
    if (navigator.onLine) {
        $5f9f4b115dc0e870$var$status = "Online";
        console.log("Online");
    } else {
        $5f9f4b115dc0e870$var$number.innerHTML = "8";
        console.log("Offline");
    }
});
$5f9f4b115dc0e870$var$glasNumber = localStorage.getItem($5f9f4b115dc0e870$var$key);
console.log($5f9f4b115dc0e870$var$glasNumber);
setInterval(()=>{
    if ($5f9f4b115dc0e870$var$key !== new Date().toLocaleString().slice(0, 10)) {
        $5f9f4b115dc0e870$var$key = new Date().toLocaleString().slice(0, 10);
        $5f9f4b115dc0e870$var$glasNumber = 0;
        localStorage.setItem($5f9f4b115dc0e870$var$key, $5f9f4b115dc0e870$var$glasNumber);
    }
}, 60000);
if ($5f9f4b115dc0e870$var$glasNumber === null) {
    $5f9f4b115dc0e870$var$glasNumber = 0;
    console.log($5f9f4b115dc0e870$var$glasNumber);
    localStorage.setItem($5f9f4b115dc0e870$var$key, $5f9f4b115dc0e870$var$glasNumber);
    $5f9f4b115dc0e870$var$number.innerHTML = 0;
} else {
    $5f9f4b115dc0e870$var$glasNumber = parseInt($5f9f4b115dc0e870$var$glasNumber);
    console.log($5f9f4b115dc0e870$var$glasNumber);
    $5f9f4b115dc0e870$var$number.innerHTML = localStorage.getItem($5f9f4b115dc0e870$var$key);
    $5f9f4b115dc0e870$var$number.innerHTML = window.localStorage.getItem($5f9f4b115dc0e870$var$key);
}
$5f9f4b115dc0e870$var$adder.addEventListener("click", ()=>{
    $5f9f4b115dc0e870$var$glasNumber = $5f9f4b115dc0e870$var$glasNumber + 1;
    localStorage.setItem($5f9f4b115dc0e870$var$key, $5f9f4b115dc0e870$var$glasNumber);
    $5f9f4b115dc0e870$var$number.innerHTML = localStorage.getItem($5f9f4b115dc0e870$var$key);
    console.log(localStorage.getItem($5f9f4b115dc0e870$var$key));
    $5f9f4b115dc0e870$var$jsConfetti.addConfetti({
        emojis: [
            "\uD83C\uDF08",
            "\u26A1\uFE0F",
            "\uD83D\uDCA5",
            "\u2728",
            "\uD83D\uDCAB",
            "\uD83C\uDF38"
        ]
    });
});
$5f9f4b115dc0e870$var$subber.addEventListener("click", ()=>{
    if ($5f9f4b115dc0e870$var$glasNumber != 0) {
        $5f9f4b115dc0e870$var$glasNumber = $5f9f4b115dc0e870$var$glasNumber - 1;
        localStorage.setItem($5f9f4b115dc0e870$var$key, $5f9f4b115dc0e870$var$glasNumber);
        $5f9f4b115dc0e870$var$number.innerHTML = localStorage.getItem($5f9f4b115dc0e870$var$key);
        window.localStorage.setItem($5f9f4b115dc0e870$var$key, $5f9f4b115dc0e870$var$glasNumber);
        $5f9f4b115dc0e870$var$number.innerHTML = window.localStorage.getItem($5f9f4b115dc0e870$var$key);
    }
    console.log(localStorage.getItem($5f9f4b115dc0e870$var$key));
});
setInterval(()=>{
    $5f9f4b115dc0e870$var$time = new Date();
    console.log($5f9f4b115dc0e870$var$time);
    $5f9f4b115dc0e870$var$hour = $5f9f4b115dc0e870$var$time.getHours();
    $5f9f4b115dc0e870$var$minute = $5f9f4b115dc0e870$var$time.getMinutes();
    if ($5f9f4b115dc0e870$var$hour === $5f9f4b115dc0e870$var$minute) $5f9f4b115dc0e870$var$jsConfetti.addConfetti();
}, 60000); //save.addEventListener('click', () => {
 //   localStorage.setItem('wynik', comment.value);
 //    console.log(comment.value);
 //})
 //load.addEventListener('click', () => {
 //   const a = localStorage.getItem('wynik')
 //   comment.value = a;
 //})


//# sourceMappingURL=index.11fd584d.js.map
